import React, { Component } from 'react';
import Layout from '../../Common/Component/Layout';
import Step1 from '../Component/Step1';
import Step2 from './Step2';

import tip from '../../../Assets/images/tip.png';

class Commercial extends Component {
  constructor(props) {
    super(props);
    this.state = {
      current: 0,
      userCanProceedToCheckout: false,
      is_footer: false,
    };
  }

  componentDidMount = () => {
    let self = this;
    setTimeout(() => {
      this.updateDimensions();
      window.addEventListener("resize", self.updateDimensions.bind(self));
    }, 500);
  }

  // Calculate dimensions
  updateDimensions = () => {
    let self = this;
    // if (window.innerWidth <= 500) {
    //   //true
    //   self.setState({
    //     is_footer: true,

    //   })
    // }
    // else {
    //   self.setState({
    //     is_footer: false,
    //   })
    // }
  }

  //user can navigate to next page
  onProceedToCheckout = (value) => {
    this.setState({userCanProceedToCheckout: value});
  };

  //render Step
  renderStep = () => {
    const { current, is_footer } = this.state;
    const {
      updateCommercialQuote,
      updateCommercialProposal,
      updateInnerCommercialProposal,
      emailInUse,
      loading,
      quote,
      error,
      checkEmail,
      addCommercialProposal,
      proposal,
      addInnerCommercialProposal,
      addInnerProposal,
      resetProposal,
      getLeadById,
    } = this.props;

    switch (current) {
    case 0:
      return (
        <Step1
          next={this.next}
          history={this.props.history}
          onProceedToCheckout={this.onProceedToCheckout}
          getQuoteById={this.props.getQuoteById}
          quote_info={this.props.quote_info}
          is_footer={is_footer}
          getAccountInfo={this.props.getAccountInfo}
          AccountInfo={this.props.AccountInfo} // Reducer
          checkEmail={checkEmail}
          emailInUse={emailInUse}
          GoogleApi={this.props.GoogleApi} // reducer
          getGeocodeAddress={this.props.getGeocodeAddress}
          resetGeocodeAddress={this.props.resetGeocodeAddress}
          updateCustomerLastCompletedStep={this.props.updateCustomerLastCompletedStep}
        />
      );
    case 1:
      return (
        <Step2
          next={this.next}
          onSubmit={updateCommercialQuote}
          addCommercialProposal={addCommercialProposal}
          addInnerCommercialProposal={addInnerCommercialProposal}
          updateCommercialProposal={updateCommercialProposal}
          updateInnerCommercialProposal={updateInnerCommercialProposal}
          loading={loading}
          quote={quote}
          proposal={proposal}
          addInnerProposal={addInnerProposal}
          resetProposal={resetProposal}
          error={error}
          history={this.props.history}
          is_footer={is_footer}
          updateCustomerLastCompletedStep={this.props.updateCustomerLastCompletedStep}
        />
      );

    default:
      return (
        <Step1
          next={this.next}
          history={this.props.history}
          getQouteById={this.props.getQouteById}
          quote_info={this.props.quote_info}
          onProceedToCheckout={this.onProceedToCheckout}
          is_footer={is_footer}
          getAccountInfo={this.props.getAccountInfo} // API to get logged-in user detail
          AccountInfo={this.props.AccountInfo} // Reducer
          checkEmail={checkEmail}
          emailInUse={emailInUse}
          GoogleApi={this.props.GoogleApi} // reducer
          getGeocodeAddress={this.props.getGeocodeAddress} // api
          updateCustomerLastCompletedStep={this.props.updateCustomerLastCompletedStep}
        />
      );
    }
  };

  // next page
  next = (e) => {
    this.setState({
      current: e,
      is_final_sidebar: false
    });
  }

  render() {
    let { current, userCanProceedToCheckout, is_footer } = this.state;
    return (
      <Layout noFooter={is_footer}>
        <div className="page_inner_content">
          <div className="wizard_form_wrapper commercial-col">
            <div className="wizard_top_step mb-0">
              <div className="container">
                <ul>
                  <li
                    className={current >= 0 ? 'active' : ''}
                    onClick={() => this.next(0)}
                  >
                    <span> 1</span>
                    {!is_footer || current === 0 ? <label>TELL US ABOUT YOUR COMMUNITY</label> : ''}
                  </li>
                  <li
                    className={current === 1 ? 'active' : ''}
                    onClick={() => { userCanProceedToCheckout && this.next(1) }}
                  >
                    <span>2</span>
                    {!is_footer || current === 1 ? <label>TELL US HOW WE CAN HELP YOU</label> : ''}
                  </li>
                </ul>
              </div>
            </div>

            <div className="wizard_form">
              <div className="container">
                <div className="row m-0">
                  <div className="col-md-7 col-lg-7 community_form">
                    {this.renderStep()}
                  </div>
                  <div className="col-md-5 col-lg-5 need_help">
                    <div className="help_info">
                      <img src={tip} alt="" />
                      <span className="hinfo">
                        <h3>Need help?</h3>
                        <h4>Call us at <u>1-800-366-3922</u>, or <u>chat with us</u> to learn more about how we can work together to manage pet waste for your community!</h4>
                      </span>
                    </div>
                    
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    );
  }
}

export default Commercial;